import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';

export default function MaintainedForm({ values, onChange, errors }) {
  return <ProjectTransitionFields schema={projectTransitionSchema('maintained')} values={values} onChange={onChange} errors={errors} />;
}
